import CityPageTemplate from "../city-template/CityPageTemplate";
import { adrianConfig } from "./data";

export default function AdrianPage() {
  return <CityPageTemplate config={adrianConfig} />;
}